export enum IcpPosition {
	CEO_AND_SIMILAR = "CEO_AND_SIMILAR",
	PERSONA_SEGMENT = "PERSONA_SEGMENT",
	CUSTOM = "CUSTOM",
	DEPARTMENT_SENIORITY = "DEPARTMENT_SENIORITY",
}

export enum CountrySelection {
	HQ = "HQ",
	CUSTOM = "CUSTOM",
}
